import config from 'config';
import { flattenSubscriptions } from 'utils/subscriptionUtils';

const LOAD = 'horse-racing/my-stable-entries/LOAD';
const LOAD_SUCCESS = 'horse-racing/my-stable-entries/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/my-stable-entries/LOAD_FAIL';

const initialState = {
  entries: {
    horse:[],
    trainer:[],
    jockey:[]
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        entries: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}

export function loadEntries(subscriptions) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.post(`${config.api.horseRacing.loadEntries}`, {
      data: {
        subscription: flattenSubscriptions(subscriptions, ['HORSE', 'JOCKEY', 'TRAINER'])
      }
    })
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/myStableEntries.js